import { VStack } from "apps/commons/components/Stack";
import { isLocationFormFilled } from "apps/oneOnboarding/location/isLocationFormFilled";
import { useStaticDataAtomValue } from "apps/oneOnboarding/staticDataAtom";
import { useFieldArray, useFormContext } from "react-hook-form";
import type { BulkPropertyFormData } from "../BulkPropertyFormData";
import { ErrorNotification } from "./ErrorNotification";
import { PropertyDetail } from "./PropertyDetail";

export const PropertyList = () => {
    const { control, formState, getFieldState } = useFormContext<BulkPropertyFormData>();
    const {
        cmsData: { bulkLocation },
    } = useStaticDataAtomValue();

    const { fields, remove } = useFieldArray({
        control,
        name: "propertyDataList",
        rules: {
            validate: {
                allFormsShouldBeFilled: (value) => {
                    return (
                        value.every((form) => isLocationFormFilled(form.state.id, form.city.id, form.streetAddress)) ||
                        bulkLocation.pleaseAddThePropertysLocationToContinue
                    );
                },
            },
        },
    });

    const { error } = getFieldState("propertyDataList", formState);

    return (
        <VStack gap="16">
            {error && error.root && <ErrorNotification message={error.root.message} />}
            {fields.map((field, i) => (
                <PropertyDetail
                    key={field.id}
                    id={field.propertyId}
                    onboardingId={field.onboardingId}
                    name={field.propertyName}
                    image={field.photos?.[0]?.src}
                    fieldPrefix={`propertyDataList.${i}`}
                    onDelete={() => remove(i)}
                />
            ))}
        </VStack>
    );
};
